export default {
  'US': {
    // testDriveNow: 'TEST DRIVE NOW',
    testDriveNow: 'REQUEST A DEMO',
    deployNow: 'DEPLOY NOW',
    fistName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    reqDesc: 'Requirement Description',
    createPassword: 'Create a Strong Password',
    confirmPass: 'Confirm Password',
    yourWorkEmail: 'Your Work Email',
    yourCompany: 'Your Company',
    previousEmail: 'Show user email input from previous screen',
    notSupportPhone: 'Mobile browsers are not currently supported. Please switch to a computer to try our product.',
    noTimeDeploy: 'DEPLOY NOW',
    createAcount: 'CREATE ACCOUNT',
    startNewBtn: 'Start a New Trial',
    continueGo: 'Continue',
    leftTitle1: 'Kyligence Cloud <br /> <span class="fontBold"> live demo </span> <br/> worth over <span class="fontBold">$300</span> <br/> request now for free!',
    // leftTitle1: 'Kyligence Cloud<span class="fontBold"> live demo </span><br/> with over <span class="fontBold">$300</span><br/> request now for free!',
    leftTitle2: 'What can you expect? ',
    leftTitle20: 'Live demonstration',
    leftTitle21: 'Product tours with Kyligence, from data import, model creation, to analysis execution.',
    leftTitle22: 'Communication with specialists',
    leftTitle23: 'Real-time communication session with specialists, having all your questions covered.',
    deploylocale1: 'You can also ',
    applyForTrial: 'Apply for a Trial',
    freedeploy:  'Deploy Free',
    freedeployoncloud: 'On Cloud',
    freedeployonprem: 'On Premises',
    freedeployonclouddesc: 'Deploy Kyligence in your cloud environment. We support Azure, Google Cloud, AWS and HUAWEI Cloud. ',
    freedeployonpremdesc: 'Deploy Kyligence on premises.',
    deploylocale2: 'deploy Kyligence ',
    deploylocale3: 'in your own cloud environment.',
    rightTitle1: 'Join leading global businesses that use Kyligence intelligently manage their most valuable data.',
    deployTitle1: '<span class="fontBold">Deploy</span><br/> free for 30 days',
    deployTitle2: 'With this full Kyligence product trial, you will experience:',
    deployTitle2c: 'With this full Kyligence Enterprise on-premises trial, you will experience:',
    deployTitle21: 'Fast deployment',
    deployTitle22: 'Deploy and experience Kyligence for free in the cloud in just a few clicks',
    deployTitle23: 'Multiple data resources',
    deployTitle24: 'High performance analytics on data from cloud storage (Amazon S3, Microsoft ADLS, etc.) and cloud DWs/DBs (Snowflake, Synapse, Amazon RDS, Redshift, etc.)',
    deployTitle25: 'Accelerated response',
    deployTitle26: 'Vastly accelerated query response times with your BI tool of choice (Tableau, Excel, etc.)',
    deployTitle21c: 'Simple Deployment',
    deployTitle22c: 'The streamlined Kyligence installation and configuration process in 2-3 hours.',
    deployTitle23c: 'Easy Connection',
    deployTitle24c: 'How easy it is to connect to and analyze your existing data sources (Hadoop, DWs, Kafka, etc.)',
    deployTitle25c: 'Accelerated Response',
    deployTitle26c: 'Vastly accelerated query response times with your BI tool of choice (Tableau, Excel, etc.)',
    deployDrive1: 'You can also request a Kyligence Cloud ',
    deployDrive2: 'live demo ',
    deployDrive3: 'with no charge.',
    trialRemaining: 'Trial remaining: ',
    noTrail: 'There is no remaining trial left.',
    noTrail1: 'Please contact us if you need more or start deploy in your own enronment.',
    times: 'times',
    startNew: 'You do not have a running Test Drive environment.',
    startNew1: 'You can start a new trial.',
    haveCloud: 'You currently have a Test Drive environment running.',
    leftMinute: 'Trial remaining: ',
    leftMinutes: 'minutes.',
    reserveTimes: 'Sorry, <br/> Test Drive Service is under maintenance until<br/>',
    comeBack: 'Please come back later or start deploy in your own environment.',
    contactUs: 'Contact us: ',
    haveAccount1: 'Already have an account? Click ',
    haveAccount2: 'here ',
    haveAccount3: 'to login',
    willStop: 'Maintenance Notice:  Kyligence Test Drive Service Update will starting in {startTime}. This may take {duringTime} hours, during which time you will not be able to use test drive.',
    clickSubmit: 'By Clicking Submit you agree to the ',
    clickSubmit1: 'Terms of Service ',
    clickSubmit2: 'and ',
    clickSubmit3: 'Privacy Policy.',
    termsOfServiceLink: 'https://kyligence.io/terms-conditions/',
    privacyPolicyLink: 'https://kyligence.io/privacy-policy/'
  },
  'CN': {
    deployNow: '开始部署',
    // testDriveNow: '开始试用',
    testDriveNow: '申请演示',
    fistName: '名',
    lastName: '姓',
    phoneNumber: '电话号码',
    reqDesc: '需求描述',
    createPassword: '密码',
    confirmPass: '确认密码',
    previousEmail: '展示来自上一步的邮箱',
    yourWorkEmail: '请输入您的邮箱',
    yourCompany: '公司名',
    notSupportPhone: '该页面暂不支持移动端使用，请移步桌面端体验我们的产品。',
    noTimeDeploy: '立即部署',
    createAcount: '注册',
    continueGo: '继续',
    startNewBtn: '开始新的试用',
    leftTitle1: '开始价值 ￥2000+ <br/><span class="fontBold">Kyligence Cloud <br/> 1 对 1 免费在线演示</span>',
    leftTitle2: '预约演示，您将获得：',
    leftTitle20: '完整的产品体验',
    leftTitle21: '从数据导入、建模到分析的全流程操作演示。' ,
    leftTitle22: '行业专家解惑',
    leftTitle23: '与资深行业专家的交流机会，解答您的个性化问题。',
    deploylocale1: '您还可以在云平台中',
    applyForTrial: '申请试用',
    freedeploy:  '免费部署',
    freedeployoncloud: '云上部署',
    freedeployonprem: '本地部署',
    freedeployonclouddesc: '在公有云上部署 Kyligence， 支持微软 Azure、亚马逊云、华为云、Google Cloud 等主流云平台。',
    freedeployonpremdesc: '本地部署 Kyligence。',
    deploylocale2: ' 部署 Kyligence ',
    deploylocale3: ', 直接获取 30 天免费试用。',
    rightTitle1: '和全球领先企业一起使用 Kyligence，智能管理其最有价值的数据。',
    deployTitle1: '30天<span class="fontBold">免费部署</span>',
    deployTitle1x: '<span class="fontBold">免费部署</span>',
    deployTitle2: '通过此次完整的 Kyligence 产品试用，您将体验：',
    deployTitle2c: 'Kyligence 将为您提供本地版安装包，您将体验到：',
    deployTitle21: '快速部署',
    deployTitle22: '只需几次点击，即可在云端免费部署和体验 Kyligence。',
    deployTitle23: '多数据源',
    deployTitle24: '对来自云存储（Amazon S3、Microsoft ADLS 等）和云 DW/DB（Snowflake、Synapse、Amazon RDS、Redshift 等）的数据进行高性能分析。',
    deployTitle25: '加速响应',
    deployTitle26: '对接您选择的 BI 工具（Tableau、Excel 等），大大加快查询响应时间。',
    deployTitle21c: '高性能分析',
    deployTitle22c: '高性能、高并发、可拓展的 OLAP 分析能力。',
    deployTitle23c: '单一信源平台',
    deployTitle24c: '为分析师和业务用户提供统一的、经过整合及优化的全局数据视图，无缝对接各类主流 BI 产品。',
    deployTitle25c: 'AI 增强引擎',
    deployTitle26c: 'AI 增强引擎轻松响应灵活的业务需求变化您还可以在零成本的托管环境中试用 Kyligence。',
    deployDrive1: '您还可以获取',
    deployDrive2: ' Kyligence 免费的 1 对 1 在线演示',
    deployDrive3: '。',
    trialRemaining: '剩余次数: ',
    noTrail: '您的试用次数已用完。',
    noTrail1: '如果您需要进一步试用，请联系我们，或在您的云环境中开始部署。',
    times: '次',
    startNew: '您没有正在运行的试用环境。',
    startNew1: '您可以开始新的一次试用。',
    haveCloud: '您当前有一个正在运行的试用环境。',
    leftMinute: '剩余试用时间：',
    leftMinutes: '分钟。',
    reserveTimes: '抱歉，<br/> Kyligence 试用环境目前正在维护中，维护将持续到<br/>',
    comeBack: '请稍后回来或在您的云环境中开始部署。',
    contactUs: '联系我们：',
    haveAccount1: '已有账号？',
    haveAccount2: '点此登录',
    haveAccount3: ' ',
    willStop: '维护通知：Kyligence 试用环境维护将于 {startTime} 开始。大约需要 {duringTime} 个小时，在此期间您将无法试用。',
    clickSubmit: '我同意 ',
    clickSubmit1: '服务条款 ',
    clickSubmit2: '和 ',
    clickSubmit3: '隐私条款。',
    termsOfServiceLink: 'https://cn.kyligence.io/terms-and-conditions-of-kyligence-end-user-license-zh/',
    privacyPolicyLink: 'https://cn.kyligence.io/privacy-policy/'
  }
}



// WEBPACK FOOTER //
// ./App/components/renamePage/locales.js